import axios from 'axios';
import config from '@/config';

const api = axios.create({
  baseURL: config.VUE_APP_API_URL,
});

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      const event = new Event('logout');

      document.dispatchEvent(event);
    }

    return Promise.reject(error);
  }
);

export { api };
